import { render, staticRenderFns } from "./user-invite.vue?vue&type=template&id=532b1b68&"
import script from "./user-invite.vue?vue&type=script&lang=js&"
export * from "./user-invite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports